"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { createClient } from "@/lib/supabase/client";

/**
 * Header call-to-action, auth-aware on the client so the rest of the layout
 * stays statically renderable. Signed-out visitors get Log in + Sign up (styled
 * apart from the blue portfolio CTA); signed-in users get their dashboard.
 */
export function HeaderCta() {
  const [authed, setAuthed] = useState<boolean | null>(null);

  useEffect(() => {
    const sb = createClient();
    sb.auth.getSession().then(({ data }) => setAuthed(!!data.session));
    const { data: sub } = sb.auth.onAuthStateChange((_e, session) =>
      setAuthed(!!session),
    );
    return () => sub.subscription.unsubscribe();
  }, []);

  if (authed) {
    return (
      <div className="ml-1 flex shrink-0 items-center gap-0.5 sm:ml-2 sm:gap-2">
        <Link
          href="/my-jobs"
          className="telex rounded-md px-1.5 py-2 text-[10.5px] text-ink-mute transition-colors hover:bg-neutral-100 hover:text-ink sm:px-3"
        >
          My jobs
        </Link>
        <Link
          href="/dashboard"
          className="inline-flex h-9 items-center whitespace-nowrap rounded-md bg-brand-600 px-2.5 text-[13px] font-semibold text-white transition-colors hover:bg-brand-700 sm:px-4"
        >
          Dashboard
        </Link>
      </div>
    );
  }

  // Signed out (and while the session is still loading — the common case).
  return (
    <div className="ml-1 flex shrink-0 items-center gap-1 sm:ml-2 sm:gap-2">
      {/* Hidden on phones: with it, the signed-out header ran 139px past a
          390px viewport and "Sign up" was off-screen (measured 2026-09-22).
          Still one tap away — the footer's Explore column links /saved on
          every page. */}
      <Link
        href="/saved"
        className="telex hidden rounded-md px-1.5 py-2 text-[10.5px] text-ink-mute transition-colors hover:bg-neutral-100 hover:text-ink sm:inline-block sm:px-3"
      >
        Saved
      </Link>
      <Link
        href="/auth/login"
        className="inline-flex h-9 items-center whitespace-nowrap rounded-md px-2.5 text-[13px] font-semibold text-ink transition-colors hover:bg-neutral-100 sm:px-3"
      >
        Log in
      </Link>
      <Link
        href="/auth/login?next=/dashboard"
        className="inline-flex h-9 items-center whitespace-nowrap rounded-md bg-ink px-2.5 text-[13px] font-semibold text-white transition-colors hover:bg-ink/85 sm:px-4"
      >
        Sign up
      </Link>
    </div>
  );
}
